import { Link } from 'react-router-dom';
import { hotTopics } from '@/mocks/homeData';

export default function HotTopicsGrid() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {hotTopics.map((topic) => (
            <Link
              key={topic.id}
              to={topic.link}
              className="group relative aspect-[4/5] md:aspect-square rounded-2xl overflow-hidden cursor-pointer"
            >
              <img
                src={topic.image}
                alt={topic.title}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                title={topic.title}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
                <h3 className="font-heading text-xl md:text-2xl lg:text-3xl font-bold text-background-50 leading-snug mb-2">
                  {topic.title}
                </h3>
                <p className="text-background-50/70 text-sm">{topic.subtitle}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}